import { ENDPOINT } from '@/const/http'
import { reportError } from '@/services/utils/telemetry'
import { fechApiWithAuthToken } from '../clients/liberty'

export const getUserPermissionList = async (
  retryCount = 1,
  retryDelay = 1000,
) => {
  try {
    const response = await fechApiWithAuthToken({
      method: 'GET',
      url: ENDPOINT.REACH_API.GET_PERMISSIONS(),
    })
    if (response.ok) {
      const data = await response.json()
      return data
    } else {
      const error = new Error(`Error fetching permissions`)
      reportError(error, {
        endpoint: ENDPOINT.REACH_API.GET_PERMISSIONS(),
        statusCode: response.status,
      })
      throw error
    }
  } catch (error) {
    if (retryCount > 0) {
      // Wait for the specified delay
      await new Promise(resolve => setTimeout(resolve, retryDelay))
      // Retry with one less retry count
      return getUserPermissionList(retryCount - 1, retryDelay)
    }
    const endpoint = ENDPOINT.REACH_API.GET_PERMISSIONS()
    reportError(error, {
      endpoint,
    })
    throw error
  }
}
